/**
 * 메일 본문 HTML — AxiEditor 로 쓰는 메일의 작성·읽기·인용 (2026-10-14).
 *
 * ★ 같은 에디터가 내는 같은 HTML 이라 게시판 리치 거르개(`sanitizeBoardHtmlRich`)를 그대로 쓴다.
 *   서버는 `sanitizeMailBodyRich`(게시판 리치 + 메일 표 속성).
 * ★ 사용자 결정(2026-10-14): 답장·전달은 원문을 «HTML 그대로» blockquote 로 인용한다.
 */
import { textToEditorHtml } from '../editor-html';
import { sanitizeBoardHtmlRich } from './sanitize-board-rich';

/** 우리가 쓴 메일 본문을 읽기 화면에 그릴 HTML 로. */
export function sanitizeMailHtmlRich(html: string, opts: { blockImages?: boolean } = {}): string {
  return sanitizeBoardHtmlRich(html, opts);
}

function esc(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export interface QuoteSource {
  /** 원문 본문 — 이미 화면용으로 거른 HTML(HTML 메일) 또는 평문(TEXT 메일). */
  body: string;
  isHtml: boolean;
  /** 인용 머리 — 「-----Original Message-----」 다음 줄들(라벨과 값을 이미 이어 붙인 글자). */
  headerTitle: string;
  headerLines: readonly string[];
}

/**
 * 답장·전달 본문 — 빈 줄 둘 + 머리 + 원문 blockquote.
 * ★ 원문은 부르는 쪽이 «화면에 그리던 거르개»로 이미 거른 HTML 을 넘긴다(바깥 메일은 바깥 정책으로).
 *   그 뒤 에디터가 다시 거르고, 저장 때 서버 리치 프로필이 한 번 더 거른다.
 */
export function buildQuotedReplyHtml(src: QuoteSource): string {
  const original = src.isHtml ? src.body : textToEditorHtml(src.body);
  const head = `<p>${esc(src.headerTitle)}<br>${src.headerLines.map(esc).join('<br>')}</p>`;
  return `<p><br></p><p><br></p>${head}<blockquote>${original}</blockquote>`;
}

/** 작성 칸에 처음 넣을 HTML — HTML prefill 이 있으면 그것, 없으면 평문 prefill 을 HTML 로. */
export function initialComposeHtml(prefill: { body?: string; bodyHtml?: string } | null | undefined): string {
  if (prefill?.bodyHtml !== undefined) return prefill.bodyHtml;
  const text = prefill?.body ?? '';
  return text ? textToEditorHtml(text) : '';
}
